import { AIPackageReviewStatus } from './Queues';

export enum PacketStatus {
  completed = 'COMPLETED',
  completedWithFailures = 'COMPLETED_WITH_FAILURES',
  failed = 'FAILED',
  pending = 'PENDING',
  processing = 'PROCESSING',
}

export interface GetPackageStatusResponse {
  status: PacketStatus;
  created_at: string; // ISODate
  total_documents: number;
  completed_documents: number;
  failed_documents: number;
  packet: Array<any>;
  error_message?: string;
  failures: Array<any>;
}

export const PacketStatusMap: Record<PacketStatus, AIPackageReviewStatus> = {
  [PacketStatus.completed]: AIPackageReviewStatus.completed,
  [PacketStatus.completedWithFailures]: AIPackageReviewStatus.completedWithFailures,
  [PacketStatus.failed]: AIPackageReviewStatus.failed,
  [PacketStatus.pending]: AIPackageReviewStatus.pending,
  [PacketStatus.processing]: AIPackageReviewStatus.processing,
};
